document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('#formContactoWholesale');

    if (form) {
        form.addEventListener('submit', async function(e) {
            e.preventDefault();

            // Select button and store original state
            const btn = this.querySelector('button[type="submit"]');
            const btnOriginalText = btn.textContent;

            // Disable button
            btn.disabled = true;
            btn.textContent = 'Sending...';

            // Prepare data using FormData
            const formData = new FormData(this);

            // Get CSRF token from meta tag
            const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

            try {
                const response = await fetch('/wholesale', {
                    method: 'POST',
                    body: formData,
                    headers: {
                        'X-CSRF-TOKEN': csrfToken,
                        'X-Requested-With': 'XMLHttpRequest'
                        // Let Fetch set the correct Content-Type for FormData
                    }
                });

                const result = await response.json();

                if (response.ok) {
                    // Success logic
                    if (typeof swal !== 'undefined') {
                        swal("Success", result.mensaje, "success");
                    } else {
                        alert(result.mensaje || 'Message sent successfully');
                    }
                    // Reset the form
                    form.reset();
                } else {
                    const errorMessage = result.error || 'Network response was not ok';
                    throw new Error(errorMessage);
                }

            } catch (error) {
                // Error logic
                console.error('Error:', error);
                if (typeof swal !== 'undefined') {
                    swal("Error", error.message || 'Error al enviar el mensaje. Por favor intenta de nuevo.', "error");
                } else {
                    alert(error.message || 'Error al enviar el mensaje. Por favor intenta de nuevo.');
                }
            } finally {
                // Re-enable button
                btn.disabled = false;
                btn.textContent = btnOriginalText;
            }
        });
    }
});
